module.exports = __webpack_public_path__ + "static/media/leaderboard-img9.a4183bb9.jpeg";